import { CogPlayOutlineIcon } from './CogPlayOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 0238FC32-F3C6-46F5-8223-8B63D96B9749
 * name cog-play-outline
 * version: 6.4.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cog-play-outline.svg
 * tags
 * - Settings 
 */
export const GearPlayOutlineIcon = CogPlayOutlineIcon;
export default GearPlayOutlineIcon